(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/deposit-restriction/assets/javascripts/react/components/radio-buttons.js') >= 0) return;  svs.modules.push('/components/accountservices/deposit-restriction/assets/javascripts/react/components/radio-buttons.js');
'use strict';

const _svs$ui$reactForm = svs.ui.reactForm,
  RadioGroup = _svs$ui$reactForm.RadioGroup,
  RadioButton = _svs$ui$reactForm.RadioButton;
const _svs$accountservices$ = svs.accountservices.deposit_restriction.AgeGroups,
  underTwentyFive = _svs$accountservices$.underTwentyFive,
  overTwentyFive = _svs$accountservices$.overTwentyFive;
const RadioButtons = _ref => {
  let isAdult = _ref.isAdult,
    setNumberOfDeposits = _ref.setNumberOfDeposits,
    numberOfDeposits = _ref.numberOfDeposits,
    isPnp = _ref.isPnp,
    setIsSubmitted = _ref.setIsSubmitted;
  const buttons = isAdult ? overTwentyFive : underTwentyFive;
  return React.createElement(RadioGroup, {
    className: isPnp ? 'pnp-class' : '',
    multipleLines: true,
    size: 200
  }, buttons.map(button => React.createElement(RadioButton, {
    className: "js-deposit-restriction-radio-button",
    key: button.value,
    minWidth: button.minWidth,
    name: "toggle-radio-group-size-100[]",
    onChange: () => {
      setNumberOfDeposits(button.value);
      setIsSubmitted(false);
    },
    selected: numberOfDeposits === button.value,
    type: "radio",
    value: button.value
  }, button.label)));
};
svs.accountservices.deposit_restriction.RadioButtons = RadioButtons;

 })(window);